module.exports = __webpack_public_path__ + "img/coin.2827cd5f.png";